// Carries a `returnUrl` across an external OAuth (Google) round-trip. Password
// sign-in keeps it in the URL and SignInPage handles it directly, but the OAuth
// flow leaves the app entirely and lands back on the root, dropping the query
// string — so we stash it in localStorage before leaving and replay it once the
// session is established.
const KEY = "postAuthReturnUrl";

// Only same-origin relative paths are ever stored/used, to avoid an open redirect.
const isSafeInternalPath = (value: string | null): value is string => !!value && value.startsWith("/") && !value.startsWith("//");

/** Call right before redirecting to the OAuth provider. */
export function stashReturnUrlForOAuth(): void {
  try {
    const returnUrl = new URLSearchParams(window.location.search).get("returnUrl");
    if (isSafeInternalPath(returnUrl)) {
      localStorage.setItem(KEY, returnUrl);
    }
  } catch {
    // localStorage unavailable — nothing to do.
  }
}

/** Call once the session is established; navigates to the stashed path exactly once. */
export function consumePostAuthReturnUrl(): void {
  try {
    const target = localStorage.getItem(KEY);
    if (!target) return;
    localStorage.removeItem(KEY);
    if (!isSafeInternalPath(target)) return;
    const current = window.location.pathname + window.location.search;
    if (target !== current) {
      window.location.href = target;
    }
  } catch {
    // localStorage unavailable — nothing to do.
  }
}
